module.exports = __webpack_public_path__ + "img/header-weddingRingsPolar@2x.f1a568f.jpg";